module.exports = __webpack_public_path__ + "static/media/title.7096a104.png";